import { schema } from "normalizr";
import {
  processCardSide,
  processProficiencies,
} from "../../../../../../services/overleaf/utils";

export const CardSchema = new schema.Entity(
  "cards",
  {},
  {
    idAttribute: "uuid",
    processStrategy: (value, parent, key) => ({
      ...value,
      confidenceLevel: processProficiencies(value.proficiencies),
      front: processCardSide(value.front),
      back: processCardSide(value.back),
    }),
  }
);

export const DeckSchema = new schema.Entity(
  "decks",
  {
    cards: [CardSchema],
  },
  { idAttribute: "uuid" }
);
